@if (!loading) {
  <div class="row mx-0 mb-2">
    @if (deactivated) {
      <div class="col-12 alert alert-danger">
        <div>INACTIVE CLIENT</div>
        @if (client.deactivatedAt) {
          {{ client.deactivationReason }}
          ({{ client.deactivationAuthorDisplay }} {{ client.deactivatedAt | date }})
        }
      </div>
    }
    <div class="col-10 px-0">
      <h3>{{ client.humanizedName }}</h3>
    </div>
    <div class="col-2 px-0 text-end">
      @if (canManageClients) {
        <app-client-actions
          [client]="client"
          (clientChange)="onClientChange($event)" />
      }
    </div>
  </div>
  <div class="page-container">
    <div class="stats my-3 bg-light border px-3">
      <app-client-stats [client]="client" />
    </div>
    <div class="details">
      <div class="my-3">
        <h5>Client Information</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Name</label>
            <div>{{ client.name }}</div>
          </div>
          <div class="col-6">
            <label>Full Name</label>
            <div>{{ client.fullName | blankValueDash }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Status</label>
            <div>{{ client.status | titlecase }}</div>
          </div>
          <div class="col-6">
            <label>Terminated</label>
            <div>{{ client.terminated ? 'Yes' : 'No' }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>HRSA IDS</label>
            <div>{{ client.effectiveHrsaIdStrings.join(', ') | blankValueDash }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Client Logo</label>
            @if (client.logoUrl) {
              <div><img src="{{ client.logoUrl }}" style="max-height: 100px;" /></div>
            }
            @if (!client.logoUrl) {
              <div><app-blank-value-dash /></div>
            }
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Super Client</label>
            @if (client.superClient) {
              <div>
                <a routerLink="/capture-admin/client-management/clients/{{client.superClient.id}}">
                  {{ client.superClient.humanizedName }}
                </a>
              </div>
            }
            @if (!client.superClient) {
              <div><app-blank-value-dash /></div>
            }
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Deal Information</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Date Deal Closed</label>
            <div>{{ client.dateDealClosed | date: 'MM/dd/yyyy' | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>Go Live Date</label>
            <div>{{ client.goLiveDate | date: 'MM/dd/yyyy' | blankValueDash }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Annual Contract Value</label>
            <div>{{ client.annualContractValue | currency | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>1st Year Estimated Value</label>
            <div>{{ client.firstYearEstimatedValue | currency | blankValueDash }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Adjustment</label>
            <div>{{ client.adjustment | currency }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Address & Contact</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Address</label>
            <div>
              @if (client.address1) {
                <div>{{ client.address1 }}</div>
              }
              @if (client.address2) {
                <div>{{ client.address2 }}</div>
              }
              <div>
                @if (client.city) {
                  <span>
                    {{ client.city }}@if (client.city && client.state) {
                    <span>, </span>
                    } {{ client.state }}
                  </span>
                }
                @if (client.zip) {
                  <span>{{ client.zip }}</span>
                }
              </div>
              @if (!client.address1 && !client.address2 && !client.city && !client.state && !client.zip) {
                <div>
                  <app-blank-value-dash />
                </div>
              }
            </div>
          </div>
          <div class="col-6">
            <label>Local Fax Number</label>
            <div>
              <app-phone-number [number]="client.faxLocal" />
            </div>
            <label>Toll Free Fax Number</label>
            <div>
              <app-phone-number [number]="client.faxTollfree" />
            </div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Claim Information</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Applicable Claim Types</label>
            <div>{{ applicableToClaimsTypes().join(', ') | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>Referral Claim Identifier Prefixes</label>
            <div>{{ client.effectiveClaimIdentifierPrefixes.join(', ') | blankValueDash }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Invoicing Information</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Invoicing Terms</label>
            <div>{{ client.invoicingTerms | titlecase | blankValueDash}}</div>
          </div>
          <div class="col-6">
            <label>Invoicing Terms Rate</label>
            <div>{{ client.invoicingTermsRate | blankValueDash }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>ESP</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Submitting to ESP?</label>
            <div>{{ (client.submittingToEsp === null ? null : client.submittingToEsp ? 'Yes' : 'No' ) | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>ESP Submit Start Date</label>
            <div>{{ client.espSubmitStartDate | date: 'MM/dd/yyyy' | blankValueDash }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Direct Messaging</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Direct Enabled</label>
            <div>{{ client.directEnabled ? 'Yes' : 'No' }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Direct Client Sending Address</label>
            <div>{{ client.directSendingAddress | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>Direct Client Receiving Address</label>
            <div>
              {{ client.directReceivingAddress | blankValueDash }}
              <div>
                @if (client.directReceivingAddress) {
                  <app-send-direct-test-message [client]="client" />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Third Party Administrators</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Live</label>
            <div>{{ liveThirdPartyAdministers() | blankValueDash }}</div>
          </div>
          <div class="col-6">
            <label>Contracted</label>
            <div>{{ contractedThirdPartyAdministers() | blankValueDash }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>EMR Systems</h5>
        <div class="row g-0">
          <div class="col-6">
             {{emrNames | blankValueDash }}
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Walgreens Secondary Client IDs</h5>
        <div class="row g-0">
          <div class="col-6">
             {{client.alternateWagBillingIdentifiers?.join(', ') | blankValueDash }}
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Miscellaneous</h5>
        <div class="row g-0">
          <div class="col-6">
            <label>Data Sharing Enabled</label>
            <div>{{ client.allowResearchDataSharing ? 'Yes' : 'No' }}</div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Allowed EHR Instance Values</label>
            <div>
              <div>{{ effectiveAllowedClientFileEhrInstanceValues | joinList | blankValueDash }}</div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Client File Monitoring</label>
            <div>
              {{ client.clientFileMonitoringEmailRecipients && client.clientFileMonitoringEmailRecipients.length > 0 ?
              client.clientFileMonitoringEmailRecipients.join(', ') :
              null | blankValueDash }}
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>File Processing Enabled?</label>
            <div>{{ client.fileProcessingEnabled ? 'Yes' : 'No' }}</div>
          </div>
          @if (client.fileProcessingDisabledAt) {
            <div class="col-6">
              <label>Last Disabled At</label>
              <div>
                {{ client.fileProcessingDisabledAt | date }}
                @if (client.fileProcessingDisabledByDisplay) {
                  ({{ client.fileProcessingDisabledByDisplay }})
                }
              </div>
            </div>
          }
        </div>
        <div class="row g-0">
          <div class="col-6">
            <label>Users Assigned To Manage Client</label>
            <div>{{ assignedUsers() | blankValueDash }}</div>
          </div>
        </div>

        <div class="row g-0">
          <div class="col-6">
            <label>Health Gorilla Enabled?</label>
            <div>{{ client.healthGorillaSettings?.enabled ? 'Yes' : 'No' }}</div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <h5>Entity Types</h5>
        <div class="row g-0">
          <div class="col-6">
            <div>{{ client.entityTypes | joinList | blankValueDash }}</div>
          </div>
        </div>
      </div>
    </div>
    @if (canManageImplementation && clientSftpCredentials.length > 0) {
      <div class="my-3">
        <h5>SFTP Information</h5>
        <div class="row g-0">
          <div class="col-3">
            <label>USERNAME</label>
            @for (credential of clientSftpCredentials; track credential) {
              <div>
                <span class="mt-3 me-1">{{ credential.username }}</span>
                <app-copy-to-clipboard [text]="credential.username" />
              </div>
            }
          </div>
          <div class="col-4">
            <label>PASSWORD</label>
            @for (credential of clientSftpCredentials; track credential) {
              <div class="row mt-0">
                <app-sensitive-string
                  (valueAccessed)="onPasswordAccessed(credential.id)"
                  [value]="credential.decryptedPassword"
                  [hiddenTextLength]="credential.passwordLength" />
                <app-copy-to-clipboard
                  (copyClicked)="onPasswordAccessed(credential.id)"
                  [text]="credential.decryptedPassword" />
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <mat-spinner />
}

